import type { CClassEnum, ILightingClassConfig, MClassEnum, PClassEnum } from "types";

type RoadKey = "main" | "leftBorder" | "rightBorder";

export const resolveClassByRoad = (
  road: RoadKey,
  roadClasses: ILightingClassConfig["roadClasses"],
  borderAreaLeftClasses: ILightingClassConfig["borderAreaLeftClasses"],
  borderAreaRightClasses: ILightingClassConfig["borderAreaRightClasses"]
): MClassEnum | CClassEnum | PClassEnum | undefined => {
  if (road === "main") return roadClasses;
  if (road === "leftBorder") return borderAreaLeftClasses;
  return borderAreaRightClasses;
};
